module.exports = __webpack_public_path__ + "img/homeIcon_2.5dfdcc71.png";